import { render, staticRenderFns } from "./NotActive.vue?vue&type=template&id=0fb5355d"
import script from "./NotActive.vue?vue&type=script&lang=js"
export * from "./NotActive.vue?vue&type=script&lang=js"
import style0 from "./NotActive.vue?vue&type=style&index=0&id=0fb5355d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports